export default __webpack_public_path__ + "static/media/chitchatting.986a4526.png";